<template>
    <button
        type="button"
        class="hidden fixed right-2 bottom-12 z-50 md:flex items-center gap-2 rounded-full bg-theme-success px-4 py-3 shadow-xl text-white"
        aria-label="Soporte por WhatsApp"
        @click="promptSupport"
    >
        <SocialIcon network="whatsapp" />
        <span class="text-sm font-medium">Soporte</span>
    </button>
</template>

<script>
import { SUPPORT_WHATSAPP_LINK } from "@/common/constants";

import SocialIcon from "@/components/icons/SocialIcon.vue";

export default {
    name: "SupportWhatsappButton",
    components: { SocialIcon },
    methods: {
        promptSupport() {
            this.$toast.show({
                title: "¿Necesitas ayuda?",
                text: "Escríbenos por WhatsApp y te ayudamos.",
                icon: "💬",
                persistent: true,
                action: {
                    label: "Abrir WhatsApp",
                    handler: this.openWhatsapp
                }
            });
        },
        openWhatsapp() {
            window.open(SUPPORT_WHATSAPP_LINK, "_blank");
        }
    }
};
</script>
